module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-react-i18next/gatsby-browser.js'),
      options: {"plugins":[],"localeJsonSourceName":"locales","languages":["el","en"],"defaultLanguage":"el","redirect":false,"siteUrl":"https://litologotherapy.gr","i18nextOptions":{"interpolation":{"escapeValue":false},"keySeparator":".","nsSeparator":false}},
    },{
      plugin: require('../node_modules/gatsby-plugin-decap-cms/gatsby-browser.js'),
      options: {"plugins":[],"modulePath":"/home/runner/work/litologotherapy/litologotherapy/src/cms/cms.js","enableIdentityWidget":true,"publicPath":"admin","htmlTitle":"LitoLogotherapy Admin","includeRobots":false},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
